/** Keep async cleanup outside React render functions while preserving rejection and early-return semantics. */
export async function withFinalizer<T>(operation: () => Promise<T>, finalize: () => void): Promise<T> {
  try {
    return await operation();
  } finally {
    finalize();
  }
}
